import { LegalPageLayout } from './LegalPageLayout';

export function PrivacyPage() {
  return (
    <LegalPageLayout title="Informativa Privacy">
      <p className="mt-2 text-sm text-neutral-500">
                    Sezione A
                  </p>
      
                  <div className="mt-6 rounded-lg bg-neutral-100 p-6 text-sm text-neutral-700">
                    <p>
                      <strong>Titolare:</strong> Klaro7 S.r.l.s., Via Prospero 5/b, 10095 Grugliasco (TO), P.I. 13344040012
                    </p>
                    <p className="mt-1">
                      <strong>Email privacy:</strong>{' '}
                      <a href="mailto:privacy@klaro7.it" className="text-teal-700 underline">
                        privacy@klaro7.it
                      </a>
                    </p>
                    <p className="mt-1">
                      <strong>Data Ultima Revisione:</strong> 11 Luglio 2026
                    </p>
                  </div>
      
                  
                    {/* ---- 1. TITOLARE DEL TRATTAMENTO ---- */}
                    <h2>1. Titolare del Trattamento</h2>
                    <p>
                      Klaro7 S.r.l.s. è il Titolare del trattamento e determina le finalità e i mezzi
                      del trattamento dei dati personali raccolti tramite la piattaforma Klaro7.it.
                    </p>
      
                    {/* ---- 2. CATEGORIE DI DATI PERSONALI TRATTATI ---- */}
                    <h2>2. Categorie di Dati Personali Trattati</h2>
      
                    <h3>Dati di Registrazione e Identificativi (Utenti e Operatori)</h3>
                    <p>
                      Nome, cognome, e-mail, data di nascita (obbligatoria per Bonus Compleanno),
                      codice fiscale (solo per Operatori), credenziali di accesso.
                    </p>
      
                    <h3>Dati di Pagamento</h3>
                    <p>
                      Informazioni di transazione, IBAN o coordinate per bonifici (per Operatori),
                      dati relativi ai pagamenti (non vengono memorizzati integralmente).
                    </p>
      
                    <h3>Dati di Navigazione</h3>
                    <p>
                      Log di accesso, indirizzo IP, dati relativi alla sessione.
                    </p>
      
                    <h3>Dati di Comunicazione e Consulto</h3>
                    <p>
                      Chat, messaggi, registrazioni vocali/video solo se autorizzate e metadati
                      (data, ora, durata, Operatore).
                    </p>
      
                    <h3>Dati degli Operatori</h3>
                    <p>
                      Documenti d&apos;identità, curriculum vitae, informazioni fiscali, fotografie
                      e descrizioni professionali (Bio).
                    </p>
      
                    <h3>Dati di Verifica e Sicurezza</h3>
                    <p>
                      Numero di cellulare per verifica tramite codice OTP, per attivazione Bonus di
                      Benvenuto e prevenzione account duplicati. Ai fini di sicurezza e prevenzione
                      degli abusi sono inoltre trattati: indirizzo IP, user agent del browser e
                      modello del dispositivo rilevati in fase di registrazione, accesso e utilizzo
                      dei servizi di consulto, metadati tecnici delle sessioni e le eventuali
                      correlazioni tra account riconducibili al medesimo soggetto.
                    </p>
      
                    {/* ---- 3. FINALITÀ DEL TRATTAMENTO E BASE GIURIDICA ---- */}
                    <h2>3. Finalità del Trattamento e Base Giuridica</h2>
      
                    <h3>A. Gestione dell&apos;Account e Fornitura dei Servizi</h3>
                    <p>
                      <strong>Base giuridica:</strong> Esecuzione di un Contratto (Art. 6.1.b GDPR).
                    </p>
      
                    <h3>B. Adempimenti Legali, Fiscali e Contabili</h3>
                    <p>
                      <strong>Base giuridica:</strong> Obbligo Legale (Art. 6.1.c GDPR).
                    </p>
      
                    <h3>C. Controllo Qualità, Prevenzione Frodi e Sicurezza della Piattaforma</h3>
                    <p>
                      <strong>Base giuridica:</strong> Legittimo Interesse (Art. 6.1.f GDPR), come
                      espressamente riconosciuto dal Considerando 47 GDPR per la prevenzione delle
                      frodi.
                    </p>
                    <p>
                      A tutela dell&apos;integrità della piattaforma, delle promozioni e dei crediti
                      (incluso il Bonus di Benvenuto), Klaro7 tratta indirizzo IP, user agent,
                      modello del dispositivo, metadati di registrazione e delle sessioni di
                      consulto e le correlazioni tra account, al fine di individuare la creazione di
                      account multipli riconducibili alla stessa persona e altri utilizzi abusivi
                      dei servizi e delle promozioni.
                    </p>
                    <ul>
                      <li>
                        <strong>Nessuna decisione automatizzata:</strong> il sistema genera
                        esclusivamente segnalazioni interne sottoposte a revisione umana. Nessun
                        blocco, sospensione o revoca avviene in modo automatico (Art. 22 GDPR non
                        applicabile).
                      </li>
                      <li>
                        <strong>Conservazione:</strong> gli indirizzi IP raccolti a fini antifrode
                        sono conservati per 90 giorni; le segnalazioni risultate infondate per 30
                        giorni dalla chiusura; le segnalazioni di abuso confermato per 12 mesi, o
                        per il tempo necessario all&apos;accertamento e alla difesa di un diritto
                        (Art. 17.3.e GDPR).
                      </li>
                      <li>
                        <strong>Accesso:</strong> i dati antifrode sono accessibili esclusivamente
                        al personale amministrativo autorizzato.
                      </li>
                      <li>
                        <strong>Diritto di opposizione:</strong> l&apos;interessato può opporsi in
                        qualsiasi momento a questo trattamento ai sensi dell&apos;Art. 21 GDPR
                        scrivendo a privacy@klaro7.it; la richiesta sarà valutata bilanciando i
                        motivi addotti con l&apos;esigenza di contrasto delle frodi in corso.
                      </li>
                    </ul>
      
                    <h3>D. Tutela Legale e Gestione Contenzioso</h3>
                    <p>
                      <strong>Base giuridica:</strong> Legittimo Interesse (Art. 6.1.f GDPR).
                    </p>
      
                    <h3>E. Marketing e Newsletter</h3>
                    <p>
                      <strong>Base giuridica:</strong> Consenso (Art. 6.1.a GDPR).
                    </p>
      
                    <h3>F. Gestione Programmi Loyalty e Bonus</h3>
                    <p>
                      <strong>Base giuridica:</strong> Esecuzione di un Contratto (Art. 6.1.b GDPR),
                      poiché i bonus sono parte integrante dell&apos;offerta commerciale.
                    </p>
      
                    {/* ---- 4. REGISTRAZIONE DELLE SESSIONI ---- */}
                    <h2>4. Registrazione delle Sessioni</h2>
                    <p>
                      La registrazione include metadati e il contenuto delle comunicazioni (testo
                      chat, audio o video).
                    </p>
                    <p>
                      <strong>Base Giuridica:</strong> Legittimo interesse (Art. 6.1.f GDPR) per
                      qualità del servizio, prevenzione frodi, gestione reclami e verifica conformità
                      Operatori.
                    </p>
                    <ul>
                      <li>
                        <strong>Conservazione:</strong> massimo 12 mesi.
                      </li>
                      <li>
                        <strong>Recensioni e feedback:</strong> 24 mesi.
                      </li>
                    </ul>
      
                    {/* ---- 5. DESTINATARI E TRASFERIMENTO DEI DATI ---- */}
                    <h2>5. Destinatari e Trasferimento dei Dati</h2>
                    <p>I dati possono essere condivisi con:</p>
                    <ul>
                      <li>Provider di servizi di hosting, cloud e manutenzione tecnica.</li>
                      <li>Società di elaborazione dei pagamenti (Payment Gateway).</li>
                      <li>Commercialisti, consulenti fiscali e legali.</li>
                      <li>Autorità giudiziarie o amministrative.</li>
                      <li>
                        Operatori Klaro7 (limitatamente al nickname e contenuto comunicazione).
                      </li>
                    </ul>
                    <p>
                      <strong>DAC7:</strong> Per Operatori, dati fiscali e compensi comunicati
                      annualmente all&apos;Agenzia delle Entrate.
                    </p>
                    <p>
                      I dati sono trattati prevalentemente nello SEE. Il trasferimento extra-SEE
                      avviene solo verso Paesi con garanzie adeguate.
                    </p>
      
                    {/* ---- 6. DIRITTI DELL'INTERESSATO ---- */}
                    <h2>6. Diritti dell&apos;Interessato</h2>
                    <ul>
                      <li>
                        <strong>Diritto di Accesso:</strong> ottenere conferma del trattamento e
                        copia dei dati.
                      </li>
                      <li>
                        <strong>Diritto di Rettifica.</strong>
                      </li>
                      <li>
                        <strong>Diritto alla Cancellazione</strong> (con nota: l&apos;hash del numero
                        di cellulare viene conservato per prevenire il riutilizzo fraudolento dei
                        Bonus).
                      </li>
                      <li>
                        <strong>Diritto di Limitazione di Trattamento.</strong>
                      </li>
                      <li>
                        <strong>Diritto alla Portabilità dei Dati.</strong>
                      </li>
                      <li>
                        <strong>Diritto di Opposizione</strong> al trattamento per marketing o
                        legittimo interesse.
                      </li>
                    </ul>
                    <p>
                      Per esercitare i propri diritti è possibile inviare una richiesta a{' '}
                      <a href="mailto:privacy@klaro7.it" className="text-teal-700 underline">
                        privacy@klaro7.it
                      </a>
                      .
                    </p>
                    <p>
                      È inoltre possibile proporre reclamo all&apos;Autorità Garante per la
                      protezione dei dati personali.
                    </p>
      
                    {/* ---- DISPOSIZIONI FINALI ---- */}
                    <h2>Disposizioni Finali</h2>
                    <p>
                      Klaro7 può aggiornare la presente informativa in qualsiasi momento. Gli utenti
                      saranno informati tramite email o banner sulla piattaforma.
                    </p>
                    <p>
                      <strong>Foro Competente:</strong> Foro di Torino.
                    </p>
      
                    <hr className="my-8" />
      
                    <p className="text-sm text-neutral-500">
                      Consulta anche la nostra{' '}
                      <a href="/cookie-policy" className="text-teal-700 underline">
                        Cookie Policy
                      </a>
                      .
                    </p>
    </LegalPageLayout>
  );
}
